import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=6450f4dc&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f4dc",
  null
  
)

export default component.exports